import { Navigate } from 'react-router-dom';

import {
  LazyRoute,
  MethodologyDetail,
  RootCorsia,
  RootMethodologyArea,
  RootMethodologyOverview,
  RootOverview,
  RootScope,
  RootSupplyAndDemand,
  RootTopGHGRisks,
  RootTopGHGRisksDetail,
} from '../lazyImports';

export const compassProjectTypeChildren = [
  {
    path: 'overview',
    element: <LazyRoute Component={RootOverview} />,
    handle: { breadcrumb: '', activeTab: 'overview' },
  },
  {
    path: 'supply-and-demand',
    element: <LazyRoute Component={RootSupplyAndDemand} />,
    handle: { breadcrumb: 'Supply and demand', activeTab: 'supply-and-demand' },
  },
  {
    path: 'top-ghg-risks',
    element: <LazyRoute Component={RootTopGHGRisks} />,
    handle: { breadcrumb: 'Top GHG risks' },
    children: [
      {
        path: '',
        element: <Navigate to='additionality' replace />,
      },
      {
        path: 'additionality',
        element: <LazyRoute Component={RootTopGHGRisksDetail} />,
        handle: {
          breadcrumb: 'Additionality',
          activeTab: 'additionality',
          activeTabKey: 'additionality',
          parentTab: 'top-ghg-risks',
        },
      },
      {
        path: 'over-crediting',
        element: <LazyRoute Component={RootTopGHGRisksDetail} />,
        handle: {
          breadcrumb: 'Over-crediting',
          activeTab: 'over-crediting',
          activeTabKey: 'overCrediting',
          parentTab: 'top-ghg-risks',
        },
      },
      {
        path: 'permanence',
        element: <LazyRoute Component={RootTopGHGRisksDetail} />,
        handle: {
          breadcrumb: 'Permanence',
          activeTab: 'permanence',
          activeTabKey: 'permanence',
          parentTab: 'top-ghg-risks',
        },
      },
      {
        path: 'overlapping-claims',
        element: <LazyRoute Component={RootTopGHGRisksDetail} />,
        handle: {
          breadcrumb: 'Overlapping claims',
          activeTab: 'overlapping-claims',
          activeTabKey: 'overLappingClaims',
          parentTab: 'top-ghg-risks',
        },
      },
    ],
  },
  {
    path: 'methodologies',
    element: <LazyRoute Component={MethodologyDetail} />,
    handle: { breadcrumb: 'Methodologies' },
    children: [
      {
        path: '',
        element: <Navigate to='overview' replace />,
      },
      {
        path: 'overview',
        element: <LazyRoute Component={RootMethodologyOverview} />,
        handle: {
          breadcrumb: 'Overview',
          activeTab: 'overview',
          parentTab: 'methodologies',
        },
      },
      {
        path: 'scope',
        element: <LazyRoute Component={RootScope} />,
        handle: {
          breadcrumb: 'Scope',
          activeTab: 'scope',
          activeTabKey: 'scope',
          parentTab: 'methodologies',
        },
      },
      {
        path: 'additionality',
        element: <LazyRoute Component={RootMethodologyArea} />,
        handle: {
          breadcrumb: 'Additionality',
          activeTab: 'additionality',
          activeTabKey: 'additionality',
          parentTab: 'methodologies',
        },
      },
      {
        path: 'over-crediting',
        element: <LazyRoute Component={RootMethodologyArea} />,
        handle: {
          breadcrumb: 'Over-crediting',
          activeTab: 'over-crediting',
          activeTabKey: 'overCrediting',
          parentTab: 'methodologies',
        },
      },
      {
        path: 'permanence',
        element: <LazyRoute Component={RootMethodologyArea} />,
        handle: {
          breadcrumb: 'Permanence',
          activeTab: 'permanence',
          activeTabKey: 'permanence',
          parentTab: 'methodologies',
        },
      },
      {
        path: 'overlapping-claims',
        element: <LazyRoute Component={RootMethodologyArea} />,
        handle: {
          breadcrumb: 'Overlapping claims',
          activeTab: 'overlapping-claims',
          activeTabKey: 'overLappingClaims',
          parentTab: 'methodologies',
        },
      },
      {
        path: 'corsia',
        element: <LazyRoute Component={RootCorsia} />,
        handle: {
          breadcrumb: 'CORSIA eligibility',
          activeTab: 'corsia',
          parentTab: 'methodologies',
        },
      },
    ],
  },
];
